import styled from 'styled-components';

export const MobileAppPageContainer = styled.div`
  text-align: center;
  width: 100%;
`;

export const MobileAppHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 2rem 1rem 2rem;
  .logo-image {
    width: 9.8125rem;
    height: 1.530625rem;
    display: inline-block;
  }
  button {
    font-weight: 700;
    font-size: 0.75rem;
    line-height: 1.02125rem;
    padding: 0;
    margin: 0;
    margin-left: auto;
    text-transform: uppercase;
  }
`;
export const FooterContainer = styled.footer`
  border-top: 0.2rem solid #f4f4f4;
  border-bottom: 0.2rem solid #f4f4f4;
  min-height: 2.75rem;
  padding: 0rem 1rem 0rem 1rem;
  position: fixed;
  bottom: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .left-content {
    display: flex;
    align-items: center;
  }

  p {
    font-size: 0.75rem;
    color: ${(props) => props.theme.variables.textColor};
  }
  .favlogo {
    width: 1.5rem;
    height: 1.5rem;
    margin-right: 0.5rem;
  }
  .button {
    min-height: 1.5rem;
  }
`;
